export default "__VITE_ASSET__QGm6cFw7__"